import {
  Box,
  CircularProgress,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { selectPtoBalancesData } from '../../../store/ReportsDetailsSlice/selectors';
import { useEffect, useState, useMemo } from 'react';
import { getPtoBalances } from '../../../store/ReportsDetailsSlice/actions';
import { useRows } from './hooks/useRows';
import ReportsHeader from '../../../components/Reports/ReportsHeader';
import ReusableGrid from '../../../components/Grid';
import { useColumns } from './hooks/useColumns';
import { useFooter } from './hooks/useFooter';
import DataNotFound from '../../../components/Reports/DataNotFound';

const PtoBalances = () => {
  const dispatch = useDispatch();
  const { ptoBalances, loadingpPtoBalances } = useSelector(
    selectPtoBalancesData
  );
  const [nameFilter, setNameFilter] = useState('');

  useEffect(() => {
    dispatch(getPtoBalances());
  }, [dispatch]);
  
  const rows = useRows(ptoBalances.data);

  const filteredRows = useMemo(() => {
    if (!nameFilter.trim()) {
      return rows;
    }
    return rows.filter((row) =>
      row.name?.toLowerCase().includes(nameFilter.toLowerCase())
    );
  }, [rows, nameFilter]);

  const columns = useColumns();
  const footer = useFooter(filteredRows);

  const clearFilter = () => {
    setNameFilter('');
  };

  return (
    <Paper className="p-4" sx={{ marginTop: '1rem' }}>
      <ReportsHeader title="PTO Balances Report Details" />

      {loadingpPtoBalances ? (
        <Box
          sx={{ minHeight: '30px' }}
          className="w-10 h-10 d-flex justify-content-center align-items-center"
        >
          <CircularProgress size={32} />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            gap: 4,
            flexDirection: 'column',
            height: 'calc(100vh - 144px)',
          }}
        >
          <TextField
            label="Search by Name"
            variant="outlined"
            size="small"
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
            sx={{ maxWidth: 300 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: nameFilter && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear filter"
                    onClick={clearFilter}
                    edge="end"
                    size="small"
                  >
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {filteredRows.length === 0 ? (
            <DataNotFound />
          ) : (
            <ReusableGrid
              columns={columns}
              rows={filteredRows}
              footer={footer}
              minWidth={1600}
              withScroll={true}
            />
          )}
        </Box>
      )}
    </Paper>
  );
};

export default PtoBalances;
